import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=6ba1791b&scoped=true&"
import script from "./Confirm.vue?vue&type=script&lang=ts&"
export * from "./Confirm.vue?vue&type=script&lang=ts&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=6ba1791b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1791b",
  null
  
)

export default component.exports